import { getFollowList, getFollowTags } from "@/cacheData";
const state = {
    CloseIframeTag: null, // 关闭iframe
    initFollowTags: false,
    FollowTagsList: [], // 关注标签
    initFollowList: false,
    FollowList: [] // 关注车辆
};

const getters = {

};
const mutations = {
    setCloseIframeTag(state, data) {
        state.CloseIframeTag = data;
    },
    setFollowTags(state, data) {
        state.initFollowTags = true;
        state.FollowTagsList = data;
    },
    addFollowTags(state, data) {
        state.FollowTagsList.push(data);
    },
    delFollowTags(state, id) {
        const index = state.FollowTagsList.findIndex(item => item.TagGUID == id);
        if (index != -1) {
            state.FollowTagsList.splice(index, 1);
        }
    },
    setFollowList(state, data) {
        state.initFollowList = true;
        state.FollowList = data;
    },
    addFollowList(state, data) {
        state.FollowList.push(data);
    },
    delFollowList(state, data) {
        const index = state.FollowList.findIndex(
            item => item.TagGUID == data.TagGUID && item.CarID == data.CarID
        );
        if (index != -1) {
            state.FollowList.splice(index, 1);
        }
    }
};
const actions = {
    async fetchFollowTags({ state, commit }) {
      if (state.initFollowTags) return;
      commit("setFollowTags", await getFollowTags());
    },
    async fetchFollowList({ state, commit }) {
      if (state.initFollowList) return;
      commit("setFollowList", await getFollowList());
    }
  };

export default { state, getters, mutations, actions };
